<script setup> 
import PremiumPageHeader from '@/Components/PremiumPageHeader.vue';
import { ref } from "vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head } from '@inertiajs/inertia-vue3';
import { mdiPlusCircle, mdiFilePdfBox, mdiFileTableOutline, mdiInformationOutline, mdiPrinter, mdiContentSave } from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';
import BaseButtons from "@/Components/BaseButtons.vue";
import BaseButton from "@/Components/BaseButton.vue";
import BaseIcon from "@/Components/BaseIcon.vue";
import IconRounded from "@/Components/IconRounded.vue";
import * as XLSX from "xlsx"


const props = defineProps({
	//records: Array,
	template: String,
	title: String,
	fileName: String,
	levels: Object,
	classrooms: Object,
	classroomsugel: Object,
	//ciclos: Object,
	isAdmin: Boolean,
	isCoord: Boolean,
	plantilla: String,
	options: Object,
	anioLectivo: String,
	resource: String

});
//let elementsDisabled = getElementsByTagName('input', 'select');
const loading = ref(false)
const resource = ref(props.resource)
const errors = ref({})
const error = ref('')
const filters = {
	'status_ugel': ''
}
const options = {
	'show_activos': true, // deprecated, se usará filers
	'show_retirados': 0,
	'show_compare': 0
}
const form = ref({
	'anio_consulta': props.anioLectivo,
	'fc_anio': '2L',
	'id_level': 0,
	'id_classroom': 0,
	'id_classroom_matricula': 0,
	'id_classroom_ugel': 0,
	'options': options,
	'filters': filters,
	'is_sort_nombre': false,
	'sort_nombre': false,
	'is_sort_puntaje': false,
	'sort_puntaje': false,
	'template': props.template,
	'pos_letra_seccion': 0
})

const records = ref([])
//const id_classroom = ref(0)
//const ref_ciclo= ref(0)

const getRecords = async () => {
	if (props.template == 'studentslist') {
		if (!form.value.id_classroom_ugel && !form.value.id_classroom && !form.value.id_classroom_matricula && !form.value.id_level) { // <-- !form.value.ref_ciclo Para Periodo anual
			//this.$message.error('Seleccionar estudante');
			error.value = 'Debe escoger un aula o nivel'
			return false;
		} else {
			error.value = '';
		}
	} else {
		if (form.value.id_classroom == 0 || !form.value.id_level) {
			//this.$message.error('Seleccionar estudante');
			if (!form.value.id_classroom) error.value = 'Debe escoger un aula'
			if (!form.value.id_level) error.value += ' Debe escoger un nivel'
			return false;
		} else {
			error.value = '';
		}
	}

	loading.value = true
	records.value = []
	buttonUpgrade.value = []
	messagealert.value = []
	await axios.post(`/${resource.value}/records`, form.value)
		.then(response => {
			records.value = response.data;
		});
	loading.value = false;
	getTextSelectAula()
	if (props.template == 'calificationsbymerito') {
		procesarListado('calificationsbymerito')
	}
}

const sortNombre = () => {
	form.value.is_sort_nombre = true;
	form.value.is_sort_puntaje = false;
	form.value.sort_nombre = !form.value.sort_nombre;
	getRecords();
}

const exportFile = async (format) => {
	loading.value = true;
	// this.loadingSubmit = true;
	errors.value = {};
	console.log('cr_ugel ' + form.value.id_classroom_ugel)
	console.log('cr ' + form.value.id_classroom)
	console.log('ciclo ' + form.value.ref_ciclo)
	await axios({
		url: `/${resource.value}/export`,
		method: 'POST',
		responseType: 'blob',
		data: {
			'records': records.value,
			'format': format,
			'template': props.template,
			'id_level': form.value.id_level,
			'id_classroom': form.value.id_classroom,
			'id_classroom_ugel': form.value.id_classroom_ugel,
			'id_classroom_matricula': form.value.id_classroom_matricula,
			'anio_consulta': form.value.anio_consulta,
			'options': JSON.stringify(options)
		}
	}).then(response => {
		let res = response.data;
		if (res.type === 'application/json') {
			//this.$message.error('Error al exportar');
			console.log('Error al exportar')
		} else {
			const url = window.URL.createObjectURL(new Blob([res]));
			const link = document.createElement('a');
			link.href = url;
			//link.setAttribute('download', 'calificacioness_' + Date.now() + '.' + format);
			if (format == 'preview') {
				link.target = "_blank";
				link.setAttribute('view', props.fileName + '.html');
			} else {
				link.setAttribute('download', props.fileName + '_' + aulaText.value + '.' + format);
			}
			document.body.appendChild(link);
			link.click();
		}
	}).catch(error => {
		console.log(error);
		errors.value = error;
	}).then(() => {
		loading.value = false;
	});
	// this.loadingSubmit = false;
	//

}

const number2nota = (notaN) => {
	let nota = parseFloat(notaN).toFixed(2);
	let result = (nota < 10.50 ? 'C' : (nota >= 10.50 && nota < 13.50 ? 'B' : (nota >= 13.50 && nota < 17.50 ? 'A' : (nota >= 17.50 && nota <= 20 ? 'AD' : 'E'))))
	//console.log(nota)
	return result
}

const aulaText = ref('')
const getTextSelectAula = () => {
	if (form.value.id_classroom > 0) {
		var values = props.classrooms.map(function (o) { return o.value }) // <-- Crear una nueva lista con map aplicando una función, antes .id ahora .value
		var index = values.indexOf(form.value.id_classroom)
		//var index = form.value.id_classroom ? form.value.id_classroom : form.value.id_classroom_ugel
		aulaText.value = props.classrooms[index].label
	}

	//console.log(index)
	console.log(aulaText.value)

}

/**
 * Estructurar nuevo listado
 */
const nuevoListadoActive = ref(false)
const nuevoListado = ref([])
const procesarListado = (template) => {
	const arrObjs = []; // Array de objetos
	const arr = records.value
	if (template == 'calificationsbymerito') {
		arr.forEach((record, index) => {
			let siexiste = checkExistObject(arrObjs, 'id_student', record.id_student)

			if (siexiste) {
				arrObjs.find(item => item.id_student === record.id_student).total_acumulado += parseInt(record.promediods)
			} else {
				arrObjs.push({
					id_student: record.id_student,
					fullname: record.fullname,
					ref_ciclo: record.ref_ciclo,
					total_acumulado: record.promediods
				});
			}

		});

		// ORdenar objetos según el campo y de mayor a menor (descendente)
		orderList('total_acumulado', 'desc', arrObjs)
	}
	// Agregar más estructuras de templates con else if('') ...

	nuevoListado.value = arrObjs
	if (arrObjs.length) {
		nuevoListadoActive.value = true
	}

	console.log(nuevoListado.value.length)
}

// Si existe el objeto según el atributo en un array de objetos
const checkExistObject = (arrObj, attr, val) => {
	return arrObj.some((obj) => obj[attr] == val)
}

// Ordenar listado
const orderList = (orderfield, sort = '', objs) => {
	objs.sort((a, b) => {
		if (sort == 'asc') {
			return a[orderfield] - b[orderfield]
		} else if (sort == 'desc') {
			return b[orderfield] - a[orderfield]
		} else {
			return a[orderfield] - b[orderfield]
		}
	});
}

// Ordenar listado sólo números no string <---------------
const sortUp = ref(false)
const sortDown = ref(false)
const sortnodefine = ref(false)
const orderColumn = (orderfield, sort = '', objs = nuevoListado.value) => {

	// Si no se define sort
	if (!sort) {
		sortnodefine.value = !sortnodefine.value
		if (sortnodefine.value) {
			sort = 'asc'
			sortUp.value = false
			sortDown.value = true
		} else {
			sort = 'desc'
			sortUp.value = true
			sortDown.value = false
		}
	}

	orderList(orderfield, sort, objs)
	nuevoListado.value = objs
	console.log('ordercolumnchanged')

}

// Calcular puesto
const calcularPuesto = (puesto, lastPuntaje, puntaje) => {
	// Si hay puntajes iguales se repite los puestos, de lo contrario se mantiene el puesto anterior <-- existen puestos duplicados
	if (lastPuntaje != puntaje) {
		puesto++
	}
	console.log(lastPuntaje + ' - ' + puntaje)
	return puesto
}

// Actualizar datos academicos de estudiante
const updateAulaUgel = (id_student, ref_classroom_ugel, index) => {
	let resource = 'student'
	let formSend = {
		'id_student': id_student,
		'anio_consulta': form.value.anio_consulta,
		'ref_classroom_ugel': ref_classroom_ugel
	}

	axios.post(`/${resource}/updateaulaugel`, formSend)
		.then(response => {
			let resp = response.data;
			if (resp.success) {
				buttonUpgrade.value[index] = true
				//buttonUpgrade.value.fill(true, index, index + 1)
				console.log('Upgrade OK ' + id_student + ' - ' + index + ' : ' + resp.message)
				//console.log(buttonUpgrade.value)
			} else {
				messagealert.value[index] = resp.message
			}
		});
}

const file = ref(null)
const fileContent = ref(null)
const dataRows = ref([])
const arrayObjects = ref([])
const refClassRoomUgelFile = ref([])
const validarAnio = ref('')
const buttonUpgrade = ref([])
const messagealert = ref([])

const onChange = (event) => {
	file.value = event.target.files ? event.target.files[0] : null;
	//console.log(file.value)
}
const procesarArchivo = () => {
	validarAnio.value = form.value.anio_consulta
	dataRows.value = []
	arrayObjects.value = []
	refClassRoomUgelFile.value = []
	buttonUpgrade.value = []
	messagealert.value = []
	if (file.value) {
		//loading.value = true;
		//console.log(loading.value)
		fileContent.value = ''
		var txtPreview = false
		// text/plain
		if (!file.value.type.startsWith("text")) {
			//alert('Debe cargar un archivo excel')
			//return
		} else {
			txtPreview = true
		}

		const reader = new FileReader()
		reader.onload = (e) => {
			if (txtPreview) {
				fileContent.value = reader.result
			}
			/* Parse data */
			const bstr = e.target.result;
			const wb = XLSX.read(bstr, { type: 'binary' });
			/* Get first worksheet */
			const wsname = wb.SheetNames[0];
			const ws = wb.Sheets[wsname];
			/* Convert array of arrays */
			const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
			//console.log(data) 
			// declarar arrays
			for(let i=0; i < data.length; i++) {
				getStudent(i, data[i][7], (data.length - 1), data[i][25])
			}
			dataRows.value = data
		}
		reader.onerror = () => {
			alert('Vuelva a cargar el archivo')
			return
		}
		
		reader.readAsBinaryString(file.value);
		
		//file.value = null
		//loading.value = false;
		//console.log(loading.value)
		//console.log(arrayObjects.value)

		//let workbook = XLSX.readFile(file.value);
		//console.log('workbook1');
		//console.log(rowsExcel.value);
		//console.log('SheetNames');
		//console.log(workbook.SheetNames);
	}
}


//arrayObjects.value[0] = {'id': 0, 'apellidos': 'Sin datos'}
const canProcess = ref(true)
const getStudent = (indice, numdoc, lastindice, statusugel = '') => {
    //let url = '/reportstudentupload/getstudent?anio_consulta='+form.value.anio_consulta+'&num_doc='+numdoc;
   /*  await axios.get(url).then((response) => {
        let respuesta = response.data
		console.log(respuesta)
        //data = response.data
    }).catch((error) => {
        console.log(error);
    }); */
	if (indice == 0) {
		loading.value = true
	}
	let resource = 'student'
	
	var data = {}
	data['id'] = 0
	data['apellidos'] = 'No existe en la base de datos'
	
	let formSend = {
		'anio_consulta': form.value.anio_consulta,
		'num_doc': numdoc
	}
	
	axios.post(`/${resource}/getstudent`, formSend)
	.then(response => {
		let resp = response.data;
		console.log(resp)
		if (resp.error) {
			data['id'] = 0
			data['apellidos'] = resp.message
			arrayObjects.value[indice] = data

			// Students
			if (indice > 11) {
				arrayNoexist.value.push(indice)
			}
		} else {
			data = resp.data
			arrayObjects.value[indice] = data

			// Students
			if (indice > 11) {
				if (statusugel == 'DEFINITIVA') {
					arrayDefinitiva.value.push(data['id'])
				} else if (statusugel == 'TRASLADADO') {
					arrayTrasladado.value.push(data['id'])
				} else if (statusugel == 'EN PROCESO') {
					arrayEnProceso.value.push(data['id'])
				}
			}
		}

		// si es el útlimo entonces cerrar loader
		if (indice == lastindice) {
			loading.value = false
			canProcess.value = false
			//file.value.value = null
			//console.log(lastindice)
		}
	});
	
	
	//arrayObjects.value[indice] = data
	//return data
}

// Click a botón de actualizar en verde cuando se aplique
const updateAll = () => {
    let buttons = document.getElementsByName('buttonupdateline');
    //let count = 0
    //let lastIt = buttons.length - 1
	loading.value = true
    for (let i = 0; i < buttons.length; i++) {
		if (i == 0) {
			loading.value = true
		}
        buttons[i].click();
		if (i == (buttons.length - 1)) {
			loading.value = false
		}
    }
	loading.value = false
}

const arrayNoexist = ref([]) // Students que no exist in the system
const arrayTrasladado = ref([])
const arrayDefinitiva = ref([])
const arrayEnProceso = ref([])
const msgScUpdateStatus = ref('')
const msgErUpdateStatus = ref('')
const updateStatusSelect = ref('DEFINITIVA')
const updateStatus = (statusugel) => {
	let statussystem = 1
	let arStudents = []
	if (statusugel == 'DEFINITIVA') {
		statussystem = 1
		arStudents = arrayDefinitiva.value
	} else if (statusugel == 'TRASLADADO') {
		statussystem = 0
		arStudents = arrayTrasladado.value
	} else if (statusugel == 'EN PROCESO') {
		statussystem = 1
		arStudents = arrayEnProceso.value
	}

	let resource = 'student'
	let formSend = {
		'students': arStudents,
		'anio_consulta': form.value.anio_consulta,
		'estado_ugel': statussystem
	}

	axios.post(`/${resource}/updatestatusugel`, formSend)
		.then(response => {
			let resp = response.data;
			if (resp.success) {
				console.log('Status Ugel: ' + statusugel + ' Sistema: ' + statussystem)
				console.log(arStudents)
				msgScUpdateStatus.value = resp.message
				//console.log(buttonUpgrade.value)
			} else {
				msgErUpdateStatus.value = resp.message
			}
		});

}

const showAyuda = ref([
    { 'excelstudent': false },
    { 'silabo': false }
])
</script>

<template>
	<Head title="Comparar Planilla Ugel" />

	<BreezeAuthenticatedLayout>
		<template #header>
        <PremiumPageHeader title="{{ title }}" subtitle="Gestión de {{ title }}">
            <template #buttons>
                <BaseButton :classLabel="'hidden sm:block'"
                            color="info"
                            :icon="mdiPlusCircle"
                            small
                            label=" Nuevo"
                            class="inline-flex"
                        />
            </template>
        </PremiumPageHeader>
    </template>

		<div>

			<!-- Loader -->
			<div v-if="loading" class="flex flex-col justify-center items-center md:h-[calc(100vh_-113px)] h-[calc(100vh-_114px)] absolute bottom-0 bg-white w-full z-50 bg-opacity-80">
				<!-- LRR Loader Pulso <div class="mb-10">
                    <div class="relative inline-flex">
                        <div class="w-8 h-8 bg-rose-600 rounded-full"></div>
                        <div class="w-8 h-8 bg-rose-600 rounded-full absolute top-0 left-0 animate-ping"></div>
                        <div class="w-8 h-8 bg-rose-600 rounded-full absolute top-0 left-0 animate-pulse"></div>
                    </div>
                </div> -->
				<div class="border-gray-300 h-20 w-20 animate-spin rounded-full border-8 border-t-rose-600 mb-10" />
				<p class="text-rose-600">Procesando ...</p>
				<!-- LRR Button loader <div>
                    <button type="button"
                        class="inline-flex  items-center btn btn-rose text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg ">
                        <div class="border-rose-400 h-5 w-5 animate-spin rounded-full border-4 border-t-white mr-2" />
                        Cargando
                    </button>
                </div> -->
			</div>
			<div>
				<div class="bg-white rounded-md shadow-lg p-4 border" :class="loading ? 'pointer-events-none' : ''">

					
						<!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->
						<!-- <div>
                          <label for="list_periodo-choice">Escoge un periodo:</label>
                          <input type="search" placeholder="Periodo" list="list-periodos" id="list_periodo-choice" name="list_periodo-choice" style="width: 300px;">
                          <datalist
                              id="list-periodos"
                              name="list-periodos"
                              class="flat">
                              <option v-for="option in ciclos" :value="option.id">{{ option.label }}</option>
                          </datalist>
                        </div> -->


						<div class="mb-4 text-center">
							Año a comparar
							<input name="year" class="w-16 ml-3 rounded-lg" type="text" v-model="form.anio_consulta" :placeholder="confGlobal.value.CICLO_ANIO_ESCOLAR">
						</div>

						<div class="mb-4">
							<a href="#" class="group relative inline-block text-blue-500 underline hover:text-red-500 duration-300" @click="showAyuda['excelstudent'] = !showAyuda['excelstudent']">
                                Ayuda
                                <BaseIcon :path="mdiInformationOutline" size="15" />
                            </a>
							<fieldset v-if="showAyuda['excelstudent']" class="border border-gray-300 p-4 rounded-md mb-6">
								<legend class="text-lg font-bold px-2">1</legend>
								<ol>
									<li>El sistema tomará como referencia el DNI del estudiante, si no está registrado el DNI en SIAGIE, debe verificar manualmente.</li>
									<li>El nombre corto del Aula o sección debe ser corto en UGEL, Ejemplo: A, B, C, etc. De lo contrario escoja en la casilla Posición de Sección.</li>
									<br>
									<li>El formato del excel debe ser el mismo que en la imagen <b>Total de estudiantes del mismo nivel</b>. Este archivo se descarga en SIAGIE: Escoger el año escolar, Matricula, Estudiantes por sección, Imprimir todo, en la ventanita botón de guardar y escoge la opción de excel.</li>
									<br>
									<img src="/ayuda/formato_excel_alumnos_SIAGIE.png" class="w-auto"/>
								</ol>
								<br>
							</fieldset>
						</div>

						<div class="grid gap-3 xl:grid-cols-4 sm:grid-cols-2 grid-cols-1 mb-4">
							<!-- <div class="col-span-1">
								<label class="block font-bold ">Nivel/Grado</label>
								<select v-model="form.id_level" class="w-full">
									<option value="0" selected></option>
									<option v-for="option in levels" :value="option.value">{{ option.label }}</option>
								</select>
							</div> -->
							<template class="block">
								<label for="filters_status" class="select mb-2 ml-2">Permitir actualizar aula UGEL segun estado</label>
								<select v-model="filters.status_ugel" id="filters_status" class="ml-2">
									<option value="DEFINITIVA">DEFINITIVA</option>
									<option value="EN PROCESO">EN PROCESO</option>
									<option value="">TODO</option>
								</select>
							</template>
							<div class="col-span-1">
								<label class="block">Posición de la letra sección</label>
								<input type="text" v-model="form.pos_letra_seccion" title="cero por defecto si sólo tiene en la columna sección A, B, C. Poner 1 si es 1A, 1B, 1C">
								<br>
								<small>[cero por defecto cuando sólo hay A, B, C.][1 si es en la segunda posición ejem: es 1A, 1B.]</small>
							</div>
							
						</div>
						<div class="flex flex-col md:flex-row gap-3 mb-4">

							<!-- <template class="block">
								<label for="filters_status" class="select mb-2 ml-2">Estado</label>
								<select v-model="filters.status" id="filters_status" class="ml-2">
									<option value="DEFINITIVA">DEFINITIVA</option>
									<option value="TRASLADADO">TRASLADADO</option>
									<option value="TODO">TODO</option>
								</select>
							</template> -->
							<!-- <template v-if="!form.anio_consulta" class="block mt-2">
								<input id="show_compare" v-model="options.show_compare" type="checkbox" class="ml-2" />
								<label for="show_compare" class="checkbox mb-2 ml-2">Comparar historia {{ confGlobal.value.CICLO_ANIO_ESCOLAR }} (<span class="text-red-600">inconsistencias</span>)</label>
							</template> -->

						</div>

						<div class="flex flex-wrap gap-3"> <!-- v-if="records.length" -->
							<div class="inline-block"><input type="file" @change="onChange" /></div>
							
							<!-- <div v-if="nuevoListado.length" class="inline-block">
								<BaseButton :disabled="records.length <= 0 || loading" @click="nuevoListadoActive = !nuevoListadoActive" color="warning" :icon="mdiFileTableOutline" :label="nuevoListadoActive ? 'Ver detalle de lista' : 'Ver lista original'" small />
							</div> -->
							<div class="inline-block" v-if="canProcess">
								<BaseButton @click="procesarArchivo()" color="danger" :icon="mdiFileTableOutline" label="Procesar" small />
							</div>
							<!-- More buttons -->
							<!-- <div class="inline-block">
                            <BaseButton
                              @click="getRecords()"
                              color="danger"
                              :icon="mdiFileTableOutline"
                              label="Procesar"
                              small
                              />
                          </div> -->

						</div>
						<!-- <div class="mt-6">Total {{ dataRows.length }}</div> -->
						<br>
						<hr class="mt-2 mb-2">
						<br>
						<pre v-text="fileContent"></pre>
						<CardBox v-if="dataRows.length" class="mb-6" has-table>
							<div class="w-full overflow-x-auto">
								<!-- Listado Original -->
								<table class="table-responsive">
									<thead>
										<!-- <tr>
											<th>#</th>
											<th @click="sortNombre">Nombre
												<i v-if="form.is_sort_nombre && form.sort_nombre" class="fas fa-sort-up"></i>
												<i v-else-if="form.is_sort_nombre" class="fas fa-sort-down"></i>
												<i v-else class="fas fa-sort"></i>
											</th>
											<th>Nivel</th>
											<th>Aula estudio</th>
											<th>Aula matrícula</th>
											<th>Aula UGEL</th>
											<th>Estado</th>
											<th>Nivel UGEL</th>
											<th>Aula UGEL</th>
											<th>Action</th>
										</tr> -->
									</thead>
									<tbody>
										<span v-show="false" :set="nivel = ''"></span>
										<span v-show="false" :set="modular_code = ''"></span>
										<tr v-for="(row, index) in dataRows" :key="row.id">
											<span v-show="false" :set="buttonUpgrade.push(false)"></span>
											<span v-show="false" :set="messagealert.push('')"></span>
											
											<!--  Aula  -->
											<span v-show="false" :set="grado_ugel=(row[1] ? row[1].replace(/ /g, '') : '')"></span>
											<span v-show="false" :set="grado_ugel=(grado_ugel == 'PRIMERO' ? '1' : (grado_ugel == 'SEGUNDO' ? '2' : (grado_ugel == 'TERCERO' ? '3' : (grado_ugel == 'CUARTO' ? '4' : (grado_ugel == 'QUINTO' ? '5' : (grado_ugel == 'SEXTO' ? '6' : ''))))))"></span> 
											<span v-show="false" :set="aula_ugel=(row[2] ? row[2].replace(/ /g, '') : '')"></span>
											<span v-show="false" :set="aula_ugel_file=(nivel ? nivel : '') + (grado_ugel ? grado_ugel : '') + (aula_ugel ? Array.from(aula_ugel)[form.pos_letra_seccion] : '') + (modular_code ? modular_code : '')"></span>
											<span v-show="false" :set="refClassRoomUgelFile.push(aula_ugel_file)"></span>
											
											<!--head-->
											<template v-if="index < 11">
												<th v-if="index == 1" colspan="8">
													<span v-show="false" :set="anio_file=(row[6] ? row[6].replace(/ /g, '') : '')"></span>
													{{ anio_file = anio_file.slice(-4) }}
													<br>{{ row[6] }}
													<span v-show="false" :set="inconsistencia_anio=''"></span>
													<br><span class="text-red-500">{{ (validarAnio != anio_file ? inconsistencia_anio = 'Año del archivo difiere de la consulta' : '') }}</span>
												</th>
												<th v-if="index == 7" colspan="8">
													{{ modular_code = (row[4] ? (Number.isInteger(row[4]) ? row[4] : row[4].replace(/ /g, '')) : '') }}
													<br>{{ row[5] }}
													
													<br>{{ nivel = (row[11] ? row[11].replace(/ /g, '') : '') }}
													<span v-show="false" :set="nivel = (nivel == 'Inicial' ? 'INI' : (nivel == 'Primaria' ? 'PRIM' : (nivel == 'Secundaria' ? 'SEC' : '')))"></span>
												</th>
											</template>
											<!--Titles-->
											<template v-if="index == 11">
												<th># Orden.</th>
												<th>Nombre
												</th>
												<!-- <th>Nivel</th> -->
												<th>Aula estudio</th>
												<th>Aula matrícula</th>
												<th>Aula UGEL</th>
												<th>Estado</th>
												<th>UGEL nombre</th>
												<!-- <th>UGEL nivel</th> -->
												<th>UGEL aula</th>
												<th>UGEL estado</th>
												<th>Action</th>
											</template>
											<template v-if="index > 11">
                                    			<span v-show="false"></span>
												<td data-label="#">
													{{ row[0] }}
												</td>
												<template v-if="arrayObjects[index]">
													<td data-label="Nombre" >
														<Link v-if="arrayObjects[index].id" :href="'/student/card?id=' + arrayObjects[index].id" class="text-blue-600 hover:text-green-600">{{ arrayObjects[index].apellidos + ' ' + arrayObjects[index].nombres }}</Link>
														<span v-else class="text-red-600">
															{{ arrayObjects[index].apellidos }}
														</span>
													</td>
													<!-- <td data-label="Nivel">
														{{ arrayObjects[index].label_level ?? '' }}
													</td> -->
													<td data-label="Aula estudio">
														{{ arrayObjects[index].label_classroom ?? '' }}
													</td>
													<td data-label="Aula matricula">
														{{ arrayObjects[index].label_classroom_matricula ?? '' }}
													</td>
													<td data-label="Aula UGEL">
														<!-- {{ arrayObjects[index].id_classroom_ugel ? arrayObjects[index].label_classroom_ugel : '' }} -->
														{{ arrayObjects[index].ref_classroom_ugel }}
														<small :class="(modular_code == arrayObjects[index].modular_code ? '' : 'text-red-600')">
															{{ arrayObjects[index].modular_code ?? '' }}
														</small>
													</td>
													<td data-label="Estado">
														<span :class="(arrayObjects[index].status_student == 0 ? 'text-red-600' : (arrayObjects[index].status_student == 1 ? 'text-green-600' : ''))">
															{{ (arrayObjects[index].status_student == 0 ? 'Retirado' : (arrayObjects[index].status_student == 1 ? 'Activo' : (arrayObjects[index].status_student == -1 ? 'Promovido' : arrayObjects[index].status_studen))) }}
														</span>
													</td>
												</template>
												<template v-else>
													<td data-label="Nombre" colspan="4">No existe el nombre</td>
												</template>
												
												<!-- UGEL -->
												 <td data-label="UGEL Nombre">
													{{ row[12] ? row[12] + ' ' + row[16] + ' ' + row[19] : '' }}
												</td>
												<!-- <td data-label="UGEL nivel">
													{{ row.[1] ?? '' }} ->
												</td> -->
												<td data-label="UGEL aula">
													{{ refClassRoomUgelFile[index] }}
													<small v-if="arrayObjects[index]" :class="(arrayObjects[index].ref_classroom_ugel == refClassRoomUgelFile[index] ? '' : 'text-red-600')">
														{{ modular_code ?? '' }}
													</small>
												</td>
												<td data-label="UGEL estado">
													<span :class="(row[25] == 'TRASLADADO' ? 'text-red-600' : (row[25] == 'DEFINITIVA' ? 'text-green-600' : ''))">
														{{ row[25] }}
													</span>
												</td>
												<td v-if="!filters.status_ugel || (filters.status_ugel && filters.status_ugel == row[25])" data-label="Action">
													<template v-if="arrayObjects[index] && arrayObjects[index].id > 0 && !inconsistencia_anio">
														<BaseButton name="buttonupdateline" v-if="arrayObjects[index].ref_classroom_ugel != refClassRoomUgelFile[index]" :color="(!buttonUpgrade[index] ? 'info' : 'success')" :label="(!buttonUpgrade[index] ? 'Actualizar' : 'Actualizado')" small @click="updateAulaUgel(arrayObjects[index].id, refClassRoomUgelFile[index], index)" />
														<br>
														<small class="text-red-600">
															{{ messagealert[index] }}
														</small>
													</template>
												</td>
												<td data-label="Action" v-else></td>
											</template>
										</tr>
									</tbody>
								</table>
								<div class="py-4 w-full flex justify-center">
									<BaseButton :icon="mdiContentSave" color="info" label="Actualizar todo" icon-size="20" small @click="updateAll()" />
								</div>
							</div>
							<hr class="my-4">
							<div>
								<b>Estados en SIAGIE</b>
								<table  class="table-basic">
									<tr>
										<td>DEFINITIVA</td>
										<td>TRASLADADO</td>
										<td>EN PROCESO</td>
										<td>NO EXISTE</td>
									</tr>
									<tr>
										<td>{{ arrayDefinitiva.length }}</td>
										<td>{{ arrayTrasladado.length }}</td>
										<td>{{ arrayEnProceso.length }}</td>
										<td class="text-red-500">{{ arrayNoexist.length }}</td>
									</tr>

								</table>
								<div class="mt-4">
									<label for="filters_status" class="select">Actualizar estados</label>
									<select v-model="updateStatusSelect" id="filters_status" class="ml-2">
										<option value="DEFINITIVA">DEFINITIVA</option>
										<option value="TRASLADADO">TRASLADADO</option>
										<option value="EN PROCESO">EN PROCESO</option>
									</select>
									<small class="text-blue-600" v-if="updateStatusSelect == 'EN PROCESO'">En proceso de guardará como activo</small>
									<BaseButton :icon="mdiContentSave" color="info" label="Actualizar estados SIAGIE" icon-size="20" small @click="updateStatus(updateStatusSelect)" />
									<small class="text-green-600" v-if="msgScUpdateStatus">{{ msgScUpdateStatus }}</small>
									<small class="text-red-600" v-if="msgErUpdateStatus">{{ msgErUpdateStatus }}</small>
								</div>
							</div>
							<!-- {{ refClassRoomUgelFile }} -->
						</CardBox>
						<CardBox v-else>
							<CardBoxComponentEmpty />
						</CardBox>
					
				</div>
			</div>
		</div>
	</BreezeAuthenticatedLayout>
</template>